import { message } from 'antd'
import {get_previous_path} from '../utils'

import {
  BUCKET_CONTENT_PENDING,
  BUCKET_CONTENT_SUCCESS,
  BUCKET_CONTENT_ERROR,

  SELECT_BUCKET,
  DEFAULT_CONTENT_LIMIT
} from '../actions/cloud-files-system-actions'

const initialState = {
  bucket        : null,
  files         : [],
  files_loading : false,
  error         : null,

  previous_path      : null,
  current_path       : null,
  current_limit      : 30,
  last_file          : null,
  has_more_files     : false
}

export default function cloudFilesSystem(state = initialState, action = {}) {

  switch (action.type) {
    case BUCKET_CONTENT_PENDING:
      return {...initialState, files_loading: true}

    case BUCKET_CONTENT_SUCCESS:
      let files          = (action||{}).data.items ? JSON.parse(JSON.stringify((action||{}).data.items).replace(/=/g, '')) : []
      let has_more_files = files.length === DEFAULT_CONTENT_LIMIT
      let last_file      = has_more_files ? (action||{}).data.items[(action||{}).data.items.length-1] : null
      last_file          = last_file ? last_file.basename : null

      return {...state,
        bucket        : (action||{}).data.bucket ? (action||{}).data.bucket : state.bucket,
        current_path  : (action||{}).data.bucket ? ((action||{}).data.path ? (action||{}).data.path : '') : state.current_path,
        previous_path : (action||{}).data.bucket ? (get_previous_path((action||{}).data.path)) : state.previous_path,
        files_loading : false,
        error         : null,
        more_files    : ((action||{}).data.last_file && (action||{}).data.last_file !== last_file) ? files : null,
        files,
        last_file,
        has_more_files
      }

    case BUCKET_CONTENT_ERROR:
      message.error(action.message)
      return {
        ...state,
        files_loading : false,
        files         : null,
        error         : action.message
      }

    case SELECT_BUCKET:
      return {
        ...state,
        bucket       : action.bucket ? action.bucket : state.bucket,
        current_path : action.bucket ?  action.current_path : state.bucket
      }
    default:
      return state
  }
}
